export default "__VITE_ASSET__CcuBEdB0__"